import React from 'react';
import './Education.css';

const Education = () => {
  return (
    <div className='py-16 grid grid-cols justify-center'>
      <h1 className='text-white font-bold  text-3xl text-center'>MY <span className='text-primary font-bold'>EDUCATION</span></h1>

      <div className='grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mt-6'>
        <div>
          <div className='box'>
            <i className='fas fa-graduation-cap'></i>
            <span className='text-2xl font-bold text-white'>2016</span>
            <h3 className='font-bold text-primary'>JSC</h3>
            <h3 className='font-bold text-primary'>Border Guard Public High School, Sreemangal</h3>
            <p className='text-white'>I am from Border Guard Public High School of Sylhet Division in 2016 with General Subject let's get GPA 4.80 result and Grade A</p>

          </div>
          <div className=' box'>
            <i className='fas fa-graduation-cap'></i>
            <span className='text-2xl font-bold text-white'>2017-18</span>
            <h3 className='font-bold text-primary'>SSC</h3>
            <h3 className='font-bold text-primary'>Vactoria High School,Sreemangal</h3>
            <p className='text-white'>I am from Vactoria High School of Sylhet Division in 2017-18 with General Subject let's get GPA 4.63 result and pass.</p>

          </div>
          <div className='box'>
            <i className='fas fa-graduation-cap'></i>
            <span className='text-2xl font-bold text-white'>2018-19</span>
            <h3 className='font-bold text-primary'>Diploma In Engineering- Computer Science Technology</h3>
            <h3 className='font-bold text-primary'>Moulvibazar Polytechnic Institue,Moulvibazar</h3>
            <p className='text-white'>Now I am study in  6th semester Computer Science Technology Moulvibazar Polytechnic Institue.It will be end 2023 and compelete my 4years Course.</p>

          </div>

          <div className='box'>
            <i className='fas fa-graduation-cap'></i>
            <span className='text-2xl font-bold text-white'>2019</span>
            <h3 className='font-bold text-primary'>Microsoft Office </h3>
            <h3 className='font-bold text-primary'>Moulvibazar Polytechnic Institute</h3>

            <p className='text-white'>I lern almost everything about Microsoft Office like Woed, Excel, Powerpoint, Access</p>



          </div>



        </div>



        <div>

          <div className='box'>
            <i className='fas fa-graduation-cap'></i>
            <span className='text-2xl font-bold text-white'>2020</span>
            <h3 className='font-bold text-primary'>Java & Python </h3>
            <h3 className='font-bold text-primary'>Moulvibazar Polytechnic Institute</h3>

            <p className='text-white'>I lern basic program of java & Phyton but I try best I not good init.</p>



          </div>

          <div className='box'>
            <i className='fas fa-graduation-cap'></i>
            <span className='text-2xl font-bold text-white'>2020</span>
            <h3 className='font-bold text-primary'>Web Design </h3>
            <h3 className='font-bold text-primary'>Moulvibazar Polytechnic Institute</h3>

            <p className='text-white'>I lern Web Design starts from here.</p>



          </div>
          <div className='box'>
            <i className='fas fa-graduation-cap'></i>
            <span className='text-2xl font-bold text-white'>2021</span>
            <h3 className='font-bold text-primary'>IELTS</h3>
            <h3 className='font-bold text-primary'>@Mizans,Moulvibazar</h3>
            <p className='text-white'>At first complete basic course of English then I am complete IELTS course from here.</p>


          </div>
          <div className='box'>
            <i className='fas fa-graduation-cap'></i>
            <span className='text-2xl font-bold text-white'>2022</span>
            <h3 className='font-bold text-primary'>Web Development</h3>
            <h3 className='font-bold text-primary'>Moulvibazar Polytechnic Institute</h3>
            <p className='text-white'>I do a 3 year on web development course.Through which we acquire many skills web development.
              I can easily create any web site & customize it.Now I am Jr.MERN Stack Developer but I also lern new things.
            </p>



          </div>

        </div>

      </div>

    </div>
  );
};

export default Education;